"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-8-3.5c.88 0 1.5.63 1.5 1.3s-.62 1.3-1.5 1.3a.5.5 0 0 0-.5.5v1.9a.5.5 0 0 0 1 0v-1.447c1.11-.21 2-1.103 2-2.253 0-1.318-1.17-2.3-2.5-2.3s-2.5.982-2.5 2.3a.5.5 0 0 0 1 0c0-.67.62-1.3 1.5-1.3m.5 7a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0"
}), 'HelpCircleFilled');
